export const VenueMapViewContainer = () => null
